import { Input } from "antd";
import "./input.scss";
export default Input;
